export enum ExportReportType {
  Location = 'Location',
  Radius = 'Radius',
  Polygon = 'Polygon',
  DriveTimePolygon = 'DriveTimePolygon',
}
